module.exports = __webpack_public_path__ + "static/media/hotel.f2197b25.svg";